import { iotInitClient } from '@mobi/utils/awsiot'
import { serverConfigQuery } from '@core/Data/ServerConfig/query'
import { queryClient } from '@core/Data/ReactQuery/queryClient'

queryClient.fetchQuery(serverConfigQuery).then(serverConfig => {
  iotInitClient(serverConfig.eventNotificationApi)
})
